import { fi as reactfi } from '@ews/react-translations';

const fi = {
...reactfi
}
export default fi
